import { useStore } from "../../../store/store-context";
export function getTemplateType(templateContent, introductoryMessages) {
  if (!introductoryMessages) {
    return TemplateType.Custom;
  }
  switch (templateContent) {
    case introductoryMessages.proposal:
      return TemplateType.Proposal;
    case introductoryMessages.invitation:
      return TemplateType.Invitation;
    default:
      return TemplateType.Custom;
  }
}
export function useEditIntroMessage() {
  var _introductoryMessages, _introductoryMessages2;
  const introductoryMessages = useStore(state => {
    var _state$userInfo;
    return (_state$userInfo = state.userInfo) === null || _state$userInfo === void 0 || (_state$userInfo = _state$userInfo.businessSettings()) === null || _state$userInfo === void 0 ? void 0 : _state$userInfo.introductoryMessages;
  });
  const templateTypeToContent = {
    [TemplateType.Proposal]: (_introductoryMessages = introductoryMessages === null || introductoryMessages === void 0 ? void 0 : introductoryMessages.proposal) !== null && _introductoryMessages !== void 0 ? _introductoryMessages : '',
    [TemplateType.Invitation]: (_introductoryMessages2 = introductoryMessages === null || introductoryMessages === void 0 ? void 0 : introductoryMessages.invitation) !== null && _introductoryMessages2 !== void 0 ? _introductoryMessages2 : '',
    [TemplateType.Custom]: ''
  };
  return {
    templateTypeToContent,
    getTemplateTypeByMessage: templateContent => getTemplateType(templateContent, introductoryMessages)
  };
}
export let TemplateType = /*#__PURE__*/function (TemplateType) {
  TemplateType["Proposal"] = "proposal";
  TemplateType["Invitation"] = "invitation";
  TemplateType["Custom"] = "custom";
  return TemplateType;
}({});
export const templateTypeToDropdownLabel = {
  [TemplateType.Proposal]: 'New client onboarding template',
  [TemplateType.Invitation]: 'Existing client onboarding template',
  [TemplateType.Custom]: 'Custom message'
};
export const orderedTemplateTypesForDropdown = [TemplateType.Proposal, TemplateType.Invitation, TemplateType.Custom];
export const isCustomMessageType = templateType => templateType === TemplateType.Custom;